import { Ally } from "../mechanics/ally/Ally";
import Character from "../mechanics/characters/Character";

export const setAllyNewLvl = (character: Character, ally: Ally) => {
    const currensyNeedName = ally.getItemToLevelUp().name
    const currensyNeedAmount = ally.getItemToLevelUp().amountToLevelUp
    const characterCurrensies = character.getInventory().getCurrensies()
    const rigthCurrensyAmount = characterCurrensies[currensyNeedName].amount

    if (rigthCurrensyAmount >= currensyNeedAmount) {
        ally.addItemToLevelUp()

        characterCurrensies[currensyNeedName] = {
            ...characterCurrensies[currensyNeedName],
            amount: characterCurrensies[currensyNeedName].amount - currensyNeedAmount
        }
    }
}